/**
 * Common base class for global coordinators
 * ({@link GlobalPanCoordinator}, {@link GlobalRightButtonCoordinator})
 * that intercept mouse events in {@link ToolManager} before the
 * active tool.
 *
 * Captures the shared lifecycle contract. Subclass-specific mouse
 * handling remains in each coordinator because their parameter shapes
 * differ significantly.
 */
export abstract class GlobalCoordinator {
    /** Whether this coordinator is currently handling an action. */
    public abstract get isActive(): boolean;

    /**
     * The CSS cursor this coordinator wants shown over the viewports
     * right now, or undefined for no preference. Derived from the
     * coordinator's state; {@link ToolManager} reads it after every event
     * and gives it precedence over the active tool's cursor, so a
     * coordinator never writes cursor styles itself.
     */
    public abstract get cursor(): string | undefined;

    /** Cancel any active state and clean up. Called on mouse
     *  leave and during tool deactivation. */
    public abstract onMouseLeave(): void;
}
